import React, { Component } from "react";

import ProgressBar from "../../lib/progress_bar";
import {
  CONVERSION_STATE_KEY_PROCESSING,
  CONVERSION_STATE_KEY_DONE,
  CONVERSION_STATE_KEY_FAILED,
  CONVERSION_STATE_KEY_NEEDS_PROCESSING,
} from "../../../constants/conversion_states";
import get from "lodash/get";
import { If } from "react-extras";
import WarningPanel from "../../lib/warning_panel";

class MediaFileProgressBar extends Component {
  getConversionState = props => {
    return get(props.mediaFiles, props.mediaFileUUID + ".conversionState");
  };

  componentDidMount() {
    this.setState({ dontRender: !this.props.shouldRender });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.shouldRender && !nextProps.shouldRender) {
      setTimeout(() => {
        this.setState({ dontRender: true });
      }, nextProps.delayClose || 0);
    }
    if (!this.props.shouldRender && nextProps.shouldRender) {
      this.setState({ dontRender: false });
    }
  }

  getInfo(mediaFile) {
    switch (get(mediaFile, "conversionState")) {
      case CONVERSION_STATE_KEY_NEEDS_PROCESSING:
        return {
          subtitle: "Your episode is awaiting processing.",
          percent: 5,
          status: "active",
        };
      case CONVERSION_STATE_KEY_PROCESSING:
        var timeDifference = (this.props.currentTime || mediaFile.createdAt) - mediaFile.createdAt;
        if (timeDifference > 75) {
          var extension = "Almost there...";
        } else {
          extension = "It should just be a minute or so";
        }
        return {
          subtitle: "Your episode is processing. " + extension,
          percent: Math.round(Math.min(90, 10 + 90 * (timeDifference / 120))),
          status: "active",
        };
      case CONVERSION_STATE_KEY_DONE:
        return {
          subtitle: "All set! Your episode has been processed",
          percent: 100,
          status: "success",
        };
      case CONVERSION_STATE_KEY_FAILED:
        return {
          subtitle:
            "Something went wrong processing your media file. Try uploading again, or contacting support.",
          percent: 90,
          status: "error",
        };
      default:
        return {
          subtitle: "",
          percent: 0,
          status: "active",
        };
    }
  }

  render() {
    const mediaFile = get(this.props.mediaFiles, this.props.mediaFileUUID);
    const info = this.getInfo(mediaFile);
    const dontRender = get(this.state, "dontRender", true);
    const hasError = !!get(mediaFile, "convertError");
    return (
      <>
        <If condition={!dontRender}>
          <div className="episode-page__progress-bar-container">
            <ProgressBar
              title={`Processing ${this.props.episodeTitle}`}
              current={info.percent}
              total={100}
              subtitle={info.subtitle}
            />
          </div>
        </If>
        {dontRender && hasError && (
          <div className="episode-page__progress-bar-container">
            <WarningPanel>
              There is an issue with the audio file. Please try with a different file or contact
              support.
            </WarningPanel>
          </div>
        )}
      </>
    );
  }
}

export default MediaFileProgressBar;
